import { z } from 'zod';

import { ContentfulSysSchema } from './contentful-sys.validator';

export const TechnicalPropertyEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    propertyName: z.string(),
    value: z.string(),
    minValue: z.number(),
    maxValue: z.number(),
    testingMethod: z.string(),
    unit: z.enum(['SI', 'US']),
    condition: z.string().optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
